<template>
  <div>
    <el-form
      :model="editOrganizationsForm"
      ref="formedForm"
      :rules="rules"
      label-position="top"
      label-width="120px"
    >
      <el-form-item prop="egrId" label="ЕГР">
        <el-select
          clearable
          class="searchPole"
          v-model="editOrganizationsForm.egrInfo"
          filterable
          remote
          value-key="id"
          reserve-keyword
          placeholder="ЕГР"
          :remote-method="searchNames"
        >
          <el-option
            v-for="item in egrNames"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="organizationTitle" label="Наименование">
        <el-input
          placeholder="Наименование"
          v-model="editOrganizationsForm.organizationInfo.name"
        ></el-input>
      </el-form-item>

      <el-form-item prop="decimalPlaces" label="Количество знаков после запятой">
        <el-input-number
          v-model="editOrganizationsForm.decimalPlaces"
          :min="0"
          :max="15"
          :step="1"
          step-strictly
          controls-position="right"
          placeholder="Не задано"
        ></el-input-number>
      </el-form-item>
      <el-button type="primary" @click="editOrganization">Сохранить</el-button>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import notification from "@/mixins/notification";

export default {
  props: ["editOrganizationsForm"],
  name: "organizationsEdit",
  mixins: [notification],

  data() {
    return {
      rules: {
        organizationTitle: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters({
      egrIds: "GETEGRIDSLIST",
      egrNames: "GETEGRNAMESLIST",
    }),
  },

  created() {
    // el-input-number считает пустым значением undefined, а не null
    if (this.editOrganizationsForm.decimalPlaces === null) {
      this.$set(this.editOrganizationsForm, "decimalPlaces", undefined);
    }
  },

  methods: {
    searchIds(query) {
      this.getEgrIds(query);
    },

    searchNames(query) {
      if (query.length >= 3) {
        this.getEgrNames(query);
      }
    },

    getEgrNames(query) {
      this.$store.dispatch("getEgrNames", { query: query });
    },

    getEgrIds(query) {
      this.$store.dispatch("getEgrIds", { query: query });
    },

    editOrganization() {
      let data = {
        ...this.editOrganizationsForm,
        decimalPlaces:
          this.editOrganizationsForm.decimalPlaces === undefined
            ? null
            : this.editOrganizationsForm.decimalPlaces,
      };
      this.$store
        .dispatch("editOrganization", data)
        .then((response) => {
          if (response.data.egrInfo !== undefined) {
            this.notification("Успешно", "Организация изменена", "success");
            this.$store.dispatch("setShowModal", null);
          }
        });
    },
  },
};
</script>

<style scoped></style>
